import { ActionTypeIds } from "../ActionTypeIds";

export const ActionConfigTemplateSet = {
  actions: {
    [ActionTypeIds.SwitchAutoBidding]: { enabled: true },
    [ActionTypeIds.LoadIntoTemplates]: { enabled: true },
    [ActionTypeIds.SubmitTemplates]: { enabled: false }
  }
};
